import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=18f6bf43"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f6bf43')) {
      api.createRecord('18f6bf43', component.options)
    } else {
      api.reload('18f6bf43', component.options)
    }
    module.hot.accept("./ErrorPage.vue?vue&type=template&id=18f6bf43", function () {
      api.rerender('18f6bf43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ErrorPage.vue"
export default component.exports